import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { TOPIC } from '../store/actionTypes';
import { Topic } from './models/topics';

export const topic = createApi({
  reducerPath: TOPIC,
  baseQuery,
  tagTypes: ['Topic'],
  endpoints: builder => ({
    getTopics: builder.query<Topic[], { page: number; limit: number }>({
      query: variables => ({
        document: gql`
          query GetTopics($page: Int, $limit: Int) {
            getTopics(page: $page, limit: $limit) {
              id
              name
              description {
                language
                text
              }
              abbreviation
              topics
              objectives {
                language
                text
              }
              meta {
                active
                created
                updated
              }
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getTopics,
    }),
  }),
});

export const { useGetTopicsQuery } = topic;
